import BandPage from '../../components/BandPage';
import { ShoppingCart } from 'lucide-react';
export default function AuffuellenPage() {
  return <BandPage bandType="auffuellen" pageTitle="Auffüllen" icon={ShoppingCart} />;
}
